import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPlotly = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.75 11.5C6.16421 11.5 6.5 11.8358 6.5 12.25V18.25C6.5 18.6642 6.16421 19 5.75 19C5.33579 19 5 18.6642 5 18.25V12.25C5 11.8358 5.33579 11.5 5.75 11.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.09 11.5C14.5042 11.5 14.84 11.8358 14.84 12.25V18.25C14.84 18.6642 14.5042 19 14.09 19C13.6758 19 13.34 18.6642 13.34 18.25V12.25C13.34 11.8358 13.6758 11.5 14.09 11.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.25 8.25C18.6642 8.25 19 8.58579 19 9V18.25C19 18.6642 18.6642 19 18.25 19C17.8358 19 17.5 18.6642 17.5 18.25V9C17.5 8.58579 17.8358 8.25 18.25 8.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.92 8.25C10.3342 8.25 10.67 8.58579 10.67 9V18.25C10.67 18.6642 10.3342 19 9.92 19C9.50579 19 9.17 18.6642 9.17 18.25V9C9.17 8.58579 9.50579 8.25 9.92 8.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.67 5.75C10.67 6.16421 10.3342 6.5 9.92 6.5C9.50579 6.5 9.17 6.16421 9.17 5.75C9.17 5.33579 9.50579 5 9.92 5C10.3342 5 10.67 5.33579 10.67 5.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 5.75C6.5 6.16421 6.16421 6.5 5.75 6.5C5.33579 6.5 5 6.16421 5 5.75C5 5.33579 5.33579 5 5.75 5C6.16421 5 6.5 5.33579 6.5 5.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 9C6.5 9.41421 6.16421 9.75 5.75 9.75C5.33579 9.75 5 9.41421 5 9C5 8.58579 5.33579 8.25 5.75 8.25C6.16421 8.25 6.5 8.58579 6.5 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.84 9C14.84 9.41421 14.5042 9.75 14.09 9.75C13.6758 9.75 13.34 9.41421 13.34 9C13.34 8.58579 13.6758 8.25 14.09 8.25C14.5042 8.25 14.84 8.58579 14.84 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.84 5.75C14.84 6.16421 14.5042 6.5 14.09 6.5C13.6758 6.5 13.34 6.16421 13.34 5.75C13.34 5.33579 13.6758 5 14.09 5C14.5042 5 14.84 5.33579 14.84 5.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 5.75C19 6.16421 18.6642 6.5 18.25 6.5C17.8358 6.5 17.5 6.16421 17.5 5.75C17.5 5.33579 17.8358 5 18.25 5C18.6642 5 19 5.33579 19 5.75Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconPlotly as ReactComponent };
